// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   DatePicker,
//   DateField,
//   PickersLayout,
// } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { PickersActionBarProps } from "@mui/x-date-pickers/PickersActionBar";
// import dayjs, { Dayjs } from "dayjs";
// import {
//   Button,
//   Box,
//   Stack,
//   InputAdornment,
//   IconButton,
// } from "@mui/material";
// import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
// import { useDispatch } from "react-redux";
// import {
//   useCreateCompanyPreferenceMutation,
//   useListCompanyPreferenceQuery,
//   companyPreferenceApi,
// } from "../../redux/apis/companyPreference.api";
// import { useAppSelector } from "../../redux";
// import { CreateCompanyPreferenceInput } from "../../graphql";
// import { showWarningSnackbar } from "../snackBar/snakbar";
// import { useLocation } from "react-router-dom";

// function clampDate(d: Dayjs, min?: Dayjs, max?: Dayjs): Dayjs {
//   let out = d;
//   if (min && out.isBefore(min, "day")) out = min;
//   if (max && out.isAfter(max, "day")) out = max;
//   return out;
// }

// const CustomActionBar = ({
//   onAccept,
//   onCancel,
//   onQuickSelect,
// }: PickersActionBarProps & {
//   onQuickSelect: (type: "today" | "yesterday") => void;
// }) => (
//   <Box
//     className="MuiPickersLayout-actionBar"
//     sx={{
//       display: "flex",
//       justifyContent: "space-between",
//       alignItems: "center",
//       borderTop: "1px solid rgba(0,0,0,0.12)",
//       backgroundColor: "#fff",
//       px: 2,
//       py: 0.75,
//       order: 2,
//     }}
//   >
//     <Box sx={{ display: "flex", gap: 1 }}>
//       <Button size="small" onClick={() => onQuickSelect("today")}>
//         Today
//       </Button>
//       <Button size="small" onClick={() => onQuickSelect("yesterday")}>
//         Yesterday
//       </Button>
//     </Box>
//     <Box sx={{ display: "flex", gap: 1 }}>
    
//       <Button size="small" onClick={onAccept}>
//         OK
//       </Button>
//     </Box>
//   </Box>
// );

// function CustomLayout(props: any) {
//   return (
//     <PickersLayout
//       {...props}
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         backgroundColor: "#fff",
//         "& .MuiPickersLayout-contentWrapper": { order: 1 },
//         "& .MuiPickersLayout-actionBar": {
//           order: 2,
//           borderTop: "1px solid rgba(0,0,0,0.12)",
//         },
//       }}
//     />
//   );
// }

// const MyPostingDate: React.FC = () => {
//   const fy = useAppSelector(
//     (state: any) => state.userPrefrenceandReducer.financialYear
//   );
//   const dispatch = useDispatch();
//   const location = useLocation();

//   const { data: companyPreference } =
//     useListCompanyPreferenceQuery(undefined, {});
//   const [createCompanyPreference, { isLoading: creating }] =
//     useCreateCompanyPreferenceMutation();

//   const currentFYId = fy?.financialyearid;
//   const postingDatePref = companyPreference?.find(
//     (p: any) =>
//       p.attributetypecd === "MyPostingDate" &&
//       String(p.additionalvalue ?? "") === String(currentFYId ?? "")
//   );

//   const savedPostingDate = useMemo(() => {
//     const val = postingDatePref?.attributevalue
//       ? dayjs.unix(postingDatePref.attributevalue)
//       : dayjs.unix(fy?.startdate ?? 0);
//     return val?.isValid() ? val : null;
//   }, [postingDatePref?.attributevalue, fy?.startdate]);

//   const { minDate, maxDate } = useMemo(() => {
//     if (!fy?.startdate || !fy?.enddate)
//       return { minDate: undefined, maxDate: undefined };
//     return {
//       minDate: dayjs.unix(fy.startdate),
//       maxDate: dayjs.unix(fy.enddate),
//     };
//   }, [fy?.startdate, fy?.enddate]);

//   const [value, setValue] = useState<Dayjs | null>(savedPostingDate ?? null);
//   const [open, setOpen] = useState(false);
//   const fieldRef = useRef<HTMLDivElement | null>(null);

//   const updatePreference = async (newValue: Dayjs | null): Promise<boolean> => {
//     try {
//       if (!newValue) return false;
//       const payload: CreateCompanyPreferenceInput = {
//         attributetypecd: "MyPostingDate",
//         attributevalue: newValue.unix(),
//         additionalvalue: String(currentFYId),
//       };
//       const res = await createCompanyPreference({
//         createCompanyPreferenceInput: payload,
//       }).unwrap();
//       if (res?.statuscode === "Error") {
//         showWarningSnackbar(res?.statusmessage);
//         return false;
//       }
//       if (res?.attributevalue)
//         setValue(dayjs.unix(res.attributevalue).startOf("day"));
//       dispatch(
//         companyPreferenceApi.util.invalidateTags?.(["listCompanyPreference"])
//       );
//       return true;
//     } catch (e) {
//       console.error("updatePreference error:", e);
//       return false;
//     }
//   };

//   useEffect(() => {
//     if (savedPostingDate) setValue(savedPostingDate.startOf("day"));
//   }, [savedPostingDate]);

//   useEffect(() => setOpen(false), [location.pathname]);

//   const handleQuickSelect = async (type: "today" | "yesterday") => {
//     const base = dayjs().startOf("day");
//     const selected = type === "today" ? base : base.subtract(1, "day");
//     const clamped = clampDate(selected, minDate, maxDate);
//     setValue(clamped);
//     const success = await updatePreference(clamped);
//     if (success) setOpen(false);
//   };

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box>
//         <Stack direction="row" alignItems="center" spacing={0.5}>
//           <DateField
//             label="My Posting Date"
//             format="DD/MM/YYYY"
//             value={value}
//             onChange={(newVal) => {
//               if (!newVal) return;
//               setValue(newVal);
//             }}
//             onBlur={async () => {
//               if (!value) return;
//               if (
//                 (minDate && value.isBefore(minDate, "day")) ||
//                 (maxDate && value.isAfter(maxDate, "day"))
//               ) {
//                 showWarningSnackbar(
//                   `Date must be between ${minDate?.format(
//                     "DD/MM/YYYY"
//                   )} and ${maxDate?.format("DD/MM/YYYY")}`
//                 );
//                 setValue(savedPostingDate);
//                 return;
//               }
//               const clamped = clampDate(value.startOf("day"), minDate, maxDate);
//               const success = await updatePreference(clamped);
//               if (!success) setValue(savedPostingDate);
//             }}
//             disabled={!minDate || !maxDate || creating}
//             slotProps={{
//               textField: {
//                 ref: fieldRef,
//                 size: "small",
//                 sx: {
//                   width: 180,
//                   "& .MuiInputLabel-root": {
//                     color: "primary.main",
//                     fontWeight: "bold",
//                   },
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "primary.main", borderWidth: 2 },
//                     "&:hover fieldset": {
//                       borderColor: "primary.main",
//                       borderWidth: 2,
//                     },
//                     "&.Mui-focused fieldset": {
//                       borderColor: "primary.main",
//                       borderWidth: 2,
//                     },
//                   },
//                   "& input.MuiInputBase-input": {
//                     color: "#1976d2 !important",
//                     fontWeight: "bold",
//                     WebkitTextFillColor: "#1976d2",
//                   },
//                 },
//                 InputProps: {
//                   endAdornment: (
//                     <InputAdornment position="end">
//                       <IconButton
//                         onClick={() => setOpen(true)}
//                         size="small"
//                         sx={{ color: "primary.main", p: 0.5 }}
//                       >
//                         <CalendarMonthIcon fontSize="small" />
//                       </IconButton>
//                     </InputAdornment>
//                   ),
//                 },
//               },
//             }}
//           />

//           <DatePicker
//             open={open}
//             onClose={() => setOpen(false)}
//             value={value}
//             onChange={async (newValue) => {
//               if (!newValue) return;
//               const clamped = clampDate(
//                 newValue.startOf("day"),
//                 minDate,
//                 maxDate
//               );
//               setValue(clamped);
//               const success = await updatePreference(clamped);
//               if (!success) setValue(savedPostingDate);
//             }}
//             minDate={minDate}
//             maxDate={maxDate}
//             format="DD/MM/YYYY"
//             slots={{
//               layout: CustomLayout,
//               actionBar: (props) => (
//                 <CustomActionBar
//                   {...props}
//                   onQuickSelect={handleQuickSelect}
//                 />
//               ),
//             }}
//             slotProps={{
//               textField: { sx: { display: "none" } },
//               popper: {
//                 anchorEl: fieldRef.current,
//                 placement: "bottom-start",
//                 modifiers: [
//                   { name: "flip", enabled: true },
//                   {
//                     name: "preventOverflow",
//                     enabled: true,
//                     options: {
//                       boundary: "viewport",
//                       altAxis: true,
//                       tether: false,
//                     },
//                   },
//                 ],
//               },
//             }}
//           />
//         </Stack>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default MyPostingDate;

//Story-LEDX-5351

import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  DatePicker,
  DateField,
  PickersLayout,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { PickersActionBarProps } from "@mui/x-date-pickers/PickersActionBar";
import dayjs, { Dayjs } from "dayjs";
import {
  Button,
  Box,
  Stack,
  InputAdornment,
  IconButton,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useDispatch } from "react-redux";
import {
  useCreateCompanyPreferenceMutation,
  useListCompanyPreferenceQuery,
  companyPreferenceApi,
} from "../../redux/apis/companyPreference.api";
import { CreateCompanyPreferenceInput } from "../../graphql";
import { showWarningSnackbar } from "../snackBar/snakbar";
import { useLocation } from "react-router-dom";
import { useFetchOpeningBalanceDateQuery } from "../../redux/apis/openingbalacedate.api";
import { useAppSelector } from "../../redux/hooks/useAppSelector";


function clampDate(d: Dayjs, min?: Dayjs, max?: Dayjs): Dayjs {
  let out = d;
  if (min && out.isBefore(min, "day")) out = min;
  if (max && out.isAfter(max, "day")) out = max;
  return out;
}

const CustomActionBar = ({
  onAccept,
  onCancel,
  onQuickSelect,
}: PickersActionBarProps & {
  onQuickSelect: (type: "today" | "yesterday") => void;
}) => (
  <Box
    className="MuiPickersLayout-actionBar"
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      borderTop: "1px solid rgba(0,0,0,0.12)",
      backgroundColor: "#fff",
      px: 2,
      py: 0.75,
      order: 2,
    }}
  >
    <Box sx={{ display: "flex", gap: 1 }}>
      <Button size="small" onClick={() => onQuickSelect("today")}>
        Today
      </Button>
      <Button size="small" onClick={() => onQuickSelect("yesterday")}>
        Yesterday
      </Button>
    </Box>
    <Box sx={{ display: "flex", gap: 1 }}>
    
      <Button size="small" onClick={onAccept}>
        OK
      </Button>
    </Box>
  </Box>
);

function CustomLayout(props: any) {
  return (
    <PickersLayout
      {...props}
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        "& .MuiPickersLayout-contentWrapper": { order: 1 },
        "& .MuiPickersLayout-actionBar": {
          order: 2,
          borderTop: "1px solid rgba(0,0,0,0.12)",
        },
      }}
    />
  );
}

const MyPostingDate: React.FC = () => {
  const fy = useAppSelector(
    (state: any) => state.userPrefrenceandReducer.financialYear
  );
  const dispatch = useDispatch();
  const location = useLocation();
const { data:openingBalanceDate, isLoading, refetch } =useFetchOpeningBalanceDateQuery (
  {
    invoicetypecd: 'Sales',
    invoiceid:0,
  },
  {
    refetchOnMountOrArgChange: true,
  }
);
  const { data: companyPreference } =
    useListCompanyPreferenceQuery(undefined, {});
  const [createCompanyPreference, { isLoading: creating }] =
    useCreateCompanyPreferenceMutation();

  const currentFYId = fy?.financialyearid;
  const postingDatePref = companyPreference?.find(
    (p: any) =>
      p.attributetypecd === "MyPostingDate" &&
      String(p.additionalvalue ?? "") === String(currentFYId ?? "")
  );

// const savedPostingDate = useMemo(() => {
//   const val =
//     postingDatePref?.attributevalue
//       ? dayjs.unix(postingDatePref.attributevalue)
//       : openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate
//       ? dayjs(openingBalanceDate.getMinMaxInvoiceDate.openingbalancedate, "YYYY-MM-DD")
//       : fy?.startdate
//       ? dayjs.unix(fy.startdate)
//       : null;
//   return val?.isValid() ? val : null;
// }, [
//   postingDatePref?.attributevalue,
//   fy?.startdate,
//   openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate,
// ]);
const savedPostingDate = useMemo(() => {
  const val =
    postingDatePref?.attributevalue
      ? dayjs.unix(postingDatePref.attributevalue)
    
      : null;
  return val ;
}, [
  postingDatePref?.attributevalue
]);


 const { minDate, maxDate } = useMemo(() => {
  if (!fy?.startdate || !fy?.enddate)
    return { minDate: undefined, maxDate: undefined };

  const baseMin = openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate
    ? dayjs(openingBalanceDate?.getMinMaxInvoiceDate?.openingbalancedate)
    : dayjs.unix(fy.startdate);

  return {
    minDate: baseMin,
    maxDate: dayjs.unix(fy.enddate),
  };
}, [openingBalanceDate, fy?.startdate, fy?.enddate]);


  const [value, setValue] = useState<Dayjs | null>(savedPostingDate ?? null);
  const [open, setOpen] = useState(false);
  const fieldRef = useRef<HTMLDivElement | null>(null);

  const updatePreference = async (newValue: Dayjs | null): Promise<boolean> => {
    try {
      if (!newValue) return false;
      const payload: CreateCompanyPreferenceInput = {
        attributetypecd: "MyPostingDate",
        attributevalue: newValue.unix(),
        additionalvalue: String(currentFYId),
      };
      const res = await createCompanyPreference({
        createCompanyPreferenceInput: payload,
      }).unwrap();
      if (res?.createCompanyPreference.statuscode === "Error") {
        const msg = res?.createCompanyPreference.statusmessage;
        if (msg) showWarningSnackbar(msg);
        return false;
      }
      if (res?.createCompanyPreference.attributevalue)
        setValue(dayjs.unix(res.createCompanyPreference.attributevalue).startOf("day"));
      dispatch(
        companyPreferenceApi.util.invalidateTags?.(["listCompanyPreference"])
      );
      return true;
    } catch (e) {
      console.error("updatePreference error:", e);
      return false;
    }
  };

  useEffect(() => {
    if (savedPostingDate) setValue(savedPostingDate.startOf("day"));
  }, [savedPostingDate]);

  useEffect(() => setOpen(false), [location.pathname]);

  const handleQuickSelect = async (type: "today" | "yesterday") => {
    const base = dayjs().startOf("day");
    const selected = type === "today" ? base : base.subtract(1, "day");
    const clamped = clampDate(selected, minDate, maxDate);
    setValue(clamped);
    const success = await updatePreference(clamped);
    if (success) setOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <DateField
            label="My Posting Date"
            format="DD/MM/YYYY"
            value={value}
            onChange={(newVal) => {
              if (!newVal) return;
              setValue(newVal);
            }}
            onBlur={async () => {
              if (!value) return;
              if (
                (minDate && value.isBefore(minDate, "day")) ||
                (maxDate && value.isAfter(maxDate, "day"))
              ) {
                // showWarningSnackbar(
                //   `Date must be between ${minDate?.format(
                //     "DD/MM/YYYY"
                //   )} and ${maxDate?.format("DD/MM/YYYY")}`
                // );
                showWarningSnackbar("Posting Date must be on or after Opening Balance Date");
                setValue(savedPostingDate);
                return;
              }
              const clamped = clampDate(value.startOf("day"), minDate, maxDate);
              const success = await updatePreference(clamped);
              if (!success) setValue(savedPostingDate);
            }}
            disabled={!minDate || !maxDate || creating}
            slotProps={{
              textField: {
                ref: fieldRef,
                size: "small",
                sx: {
                  width: 180,
                  "& .MuiInputLabel-root": {
                    color: "primary.main",
                    fontWeight: "bold",
                  },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "primary.main", borderWidth: 2 },
                    "&:hover fieldset": {
                      borderColor: "primary.main",
                      borderWidth: 2,
                    },
                    "&.Mui-focused fieldset": {
                      borderColor: "primary.main",
                      borderWidth: 2,
                    },
                  },
                  "& input.MuiInputBase-input": {
                    color: "#1976d2 !important",
                    fontWeight: "bold",
                    WebkitTextFillColor: "#1976d2",
                  },
                },
                InputProps: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setOpen(true)}
                        size="small"
                        sx={{ color: "primary.main", p: 0.5 }}
                      >
                        <CalendarMonthIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              },
            }}
          />

          <DatePicker
            open={open}
            onClose={() => setOpen(false)}
            value={value}
            onChange={async (newValue) => {
              if (!newValue) return;
              const clamped = clampDate(
                newValue.startOf("day"),
                minDate,
                maxDate
              );
              setValue(clamped);
              const success = await updatePreference(clamped);
              if (!success) setValue(savedPostingDate);
            }}
            minDate={minDate}
            maxDate={maxDate}
            format="DD/MM/YYYY"
            slots={{
              layout: CustomLayout,
              actionBar: (props) => (
                <CustomActionBar
                  {...props}
                  onQuickSelect={handleQuickSelect}
                />
              ),
            }}
            slotProps={{
              textField: { sx: { display: "none" } },
              popper: {
                anchorEl: fieldRef.current,
                placement: "bottom-start",
                modifiers: [
                  { name: "flip", enabled: true },
                  {
                    name: "preventOverflow",
                    enabled: true,
                    options: {
                      boundary: "viewport",
                      altAxis: true,
                      tether: false,
                    },
                  },
                ],
              },
            }}
          />
        </Stack>
      </Box>
    </LocalizationProvider>
  );
};

export default MyPostingDate;



